/** A citation: a plain URL (older history rows) or the URL with the regulation's title. */
export type ChatSource = string | { url: string; title?: string | null };

/** Normalise either shape to {url, title}. */
export const toSource = (s: ChatSource): { url: string; title: string | null } =>
  typeof s === 'string' ? { url: s, title: null } : { url: s.url, title: s.title ?? null };

export type Message = {
  id: number;
  sender: 'user' | 'bot';
  text: string;
  sources?: ChatSource[]; // citations for bot messages
  dbId?: number;       // backend ChatMessage.id — required to submit feedback
  feedback?: 'up' | 'down' | null; // user's thumbs rating on a bot reply
  attachmentName?: string; // filename attached to this (user) turn, shown in the bubble
  /** Set on a message added because the POST failed. The websocket may still
   *  deliver the real answer afterwards (it outlives CloudFront's 60s cap),
   *  and when it does this message is retracted rather than left above the
   *  answer — otherwise the user sees an error AND a correct reply. */
  transportError?: boolean;
};